import fetch from 'node-fetch'

export function fetchWithAuthentication(
  app: string,
  version: string,
  jwt: string,
  csrf: string
): (input: RequestInfo, init?: RequestInit) => Promise<Response> {
  return (input: RequestInfo, init?: RequestInit): Promise<Response> => {
    // @ts-ignore
    init.headers.Accept = `application/vnd.${app}.${version}+json`
    // @ts-ignore
    init.headers.Authorization = `Bearer ${jwt}`
    // @ts-ignore
    init.headers['x-csrf-token'] = csrf
    // @ts-ignore
    init.headers['user-agent'] = 'hubs-frontend-next'
    // @ts-ignore
    init.headers['version'] = version

    // @ts-ignore
    return fetch(input, init)
  }
}
